import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5199/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Task Service Functions
export const fetchTaskData = async (caseManagerId) => {
  try {
    if (!caseManagerId) {
      throw new Error('Case Manager ID is required');
    }

    const requestBody = {
      CaseManagerOrQueueId: caseManagerId,
      UserType: 'CaseManager',
      DueDateFrom: new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString(), // 3 months ago
      DueDateTo: new Date().toISOString() // Today
    };

    const response = await apiClient.post(`/task/status`, requestBody);
    return response.data;
  } catch (error) {
    console.error('Error fetching task data:', error);
    throw new Error('Failed to fetch task data');
  }
};

export const fetchMemberTaskDetails = async (params) => {
  try {
    const response = await apiClient.post(`/task/userwise`, params);
    return response.data;
  } catch (error) {
    console.error('Error fetching member task details:', error);
    throw new Error('Failed to fetch member task details');
  }
};